import { cn } from "~/utils/helpers"

const SIZES = {
  base: "h-[22px] min-w-[22px] px-[6px] pt-[1px] text-[11px]",
  sm: "h-4.5 min-w-4.5 px-1 text-[10px]",
}

export function AdjustmentCountBadge({
  count,
  size = "base",
  className,
}: {
  count: number
  /** `sm` for dense table cells that sit alongside a value. */
  size?: keyof typeof SIZES
  className?: string
}) {
  return (
    <div
      className={cn(
        "inline-flex bg-violet-100 text-violet-500 rounded-full items-center justify-center",
        SIZES[size],
        className,
      )}
    >
      {count}
    </div>
  )
}
